const ns = "FORMS_V2_FORM_FIELDS_RELATIONSHIP";
export const CREATE = `${ns}_CREATE`;
export const CREATE_COMPLETE = `${ns}_CREATE_COMPLETE`;
export const DELETE = `${ns}_DELETE`;
export const DELETE_COMPLETE = `${ns}_DELETE_COMPLETE`;
